module.exports = __webpack_public_path__ + "e21dcf948f0441471d9ff1218ae2f2ac.svg";